import { Trans } from 'react-i18next';
import { AppSwitchTasksView } from '@components/AppSwitchTasksView/index';
import { useState } from 'react';
import { AppTasks } from '@components/AppTasks/index';
import { SEARCHING_TASKS_VIEW_TYPES } from '@app/constants/searching';

export const SearchingTasks = () => {
  const [currentView, setCurrentView] = useState(
    SEARCHING_TASKS_VIEW_TYPES.LIST,
  );

  return (
    <>
      <div className="rev-o-container">
        <div className="rev-o-grid">
          <div className="rev-u-px-16 rev-o-col-12 rev-o-col--medium-9">
            <p className="rev-o-typo-heading-5 rev-u-color-primary-100">
              <Trans
                i18nKey={'searching.tasks.title'}
                components={{
                  strong: <strong className="rev-u-color-secondary-100" />,
                }}
              />
            </p>
          </div>

          <div className="rev-u-px-16 rev-o-col-12 rev-o-col--medium-3">
            <div className="c-app-switch">
              <div className="c-app-switch__items">
                {TASKS_VIEWS.map((view, viewIdx) => (
                  <AppSwitchTasksView
                    key={viewIdx}
                    view={view}
                    currentView={currentView}
                    setCurrentView={setCurrentView}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="rev-o-container">
        <div className="rev-o-grid">
          <div className="rev-o-col-12">
            <AppTasks currentView={currentView} />
          </div>
        </div>
      </div>
    </>
  );
};

const TASKS_VIEWS = Object.values(SEARCHING_TASKS_VIEW_TYPES);
